/**
 * Sheet types (spec §17 rule 3), as the API's CHECK lists them. Null is read as `other`. Only plan-view sheets can be
 * placed on the map.
 */
export type SheetType = 'plan' | 'plan_profile' | 'profile' | 'cross_section' | 'typical_section' | 'detail' | 'summary' | 'general' | 'other';

export const SHEET_TYPES: { value: SheetType; label: string }[] = [
  { value: 'plan', label: 'Plan' },
  { value: 'plan_profile', label: 'Plan and profile' },
  { value: 'profile', label: 'Profile' },
  { value: 'cross_section', label: 'Cross section' },
  { value: 'typical_section', label: 'Typical section' },
  { value: 'detail', label: 'Detail' },
  { value: 'summary', label: 'Summary' },
  { value: 'general', label: 'General' },
  { value: 'other', label: 'Other' },
];

const PLACEABLE: (SheetType | null)[] = ['plan', 'plan_profile', 'other', null];

export function sheetTypeLabel(type: SheetType | null | undefined): string {
  return SHEET_TYPES.find(t => t.value === (type ?? 'other'))?.label ?? 'Other';
}

/** Place on map is offered for plan, plan and profile, and other (null included) */
export function isPlaceableType(type: SheetType | null | undefined): boolean {
  return PLACEABLE.includes(type ?? null);
}
